const NEXT_PUBLIC_BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH
const NEXT_PUBLIC_API_CART = process.env.NEXT_PUBLIC_API_CART
const NEXT_PUBLIC_API_CONTENT = process.env.NEXT_PUBLIC_API_CONTENT
const NEXT_PUBLIC_API_CATALOG = process.env.NEXT_PUBLIC_API_CATALOG
const NEXT_PUBLIC_SAATVA_DOMAIN = process.env.NEXT_PUBLIC_SAATVA_DOMAIN

export const apiRoutes = {
    cartCheckout: `${NEXT_PUBLIC_BASE_PATH}${NEXT_PUBLIC_API_CART}`,
    content: `${NEXT_PUBLIC_BASE_PATH}${NEXT_PUBLIC_API_CONTENT}`,
    catalog: `${NEXT_PUBLIC_BASE_PATH}${NEXT_PUBLIC_API_CATALOG}`,
    imgix: process.env.NEXT_PUBLIC_IMGIX_URL
}

export const assetsPath = `${NEXT_PUBLIC_SAATVA_DOMAIN}/static/assets`

export const catalogModifiers = {
    PRE_CART: 'PRE_CART',
    EXCLUDE_PILLOW_BUNDLES: 'EXCLUDE_PILLOW_BUNDLES',
    EXCLUDE_QUILT_SETS: 'EXCLUDE_QUILT_SETS',
    EXCLUDE_NON_ACTIVE: 'EXCLUDE_NON_ACTIVE',
    RANDOM_DEFAULT_SWATCH: 'RANDOM_DEFAULT_SWATCH'
}

export const deliveryTypes = {
    direct: 'Direct',
    whiteGlove: 'White Glove'
}

export const fallbackData = [
    {
        title: 'Mattresses',
        url: `/mattresses`
    },
    {
        title: 'Furniture',
        url: `/furniture`
    },
    {
        title: 'Bedding',
        url: `/bedding`
    },
    {
        title: 'Gifts',
        url: '/gifts'
    },
    {
        title: 'Sale',
        url: '/sale'
    }
]

export const iconsPath = `${assetsPath}/icons`

export const localStorageKeys = {
    savedForLater: 'savedForLater'
}

export const regex = {
    zipCode: '^(\\d{5}([\\-]\\d{4})?)$',
    cookie: '(^|;) ?name=([^;]*)(;|$)',
    startsWithVowel: /^[aeiou].*/i
}

export const recommendedProductsListName = 'cart-recommended-products'

export const modalActions = {
    ADD: 'add',
    EDIT: 'edit'
}

export const imgixConfig = {
    MATTRESS_REMOVAL_ICON: `${process.env.NEXT_PUBLIC_SAATVA_DOMAIN}/static/assets/icons/mattress-removal.svg`,
    NO_IMAGE_AVAILABLE_ICON: `${process.env.NEXT_PUBLIC_SAATVA_DOMAIN}/static/assets/icons/no-image.svg`
}

export const envs = {
    saatvaDomain: process.env.NEXT_PUBLIC_SAATVA_DOMAIN
}

export const MATTRESS_REMOVAL_SKUS = ['mattress-removal-1', 'transportation-flat-fee']

export const staticUrls = {
    checkout: '/checkout',
    mattresses: '/mattresses'
}

export const EXTEND_SKU = 'WARRANTY-1'

export const nonEditableSkus = ['adjustable-frame', 'crib-mattress', EXTEND_SKU]

export const skipReccoStripFiltering = [
    'pillows',
    'pads',
    'topper'
]

export const pdpLinksConfig = {
    excludedTypes: ['shams', 'frames'],
    excludedSubcategories: ['pillowcases & shams'],
    excludedProductCodes: ['foundation-hd'],
    allowedProductCodes: [
        'organic-cotton-pillowcases',
        'percale-pillowcases',
        'linen-pillowcases'
    ]
}
export const couponCodes = {
    'checkoutBedding': '10OFFBEDDING'
}

export const footerTestData = {
    'mainLinks': [
        {
            'label': 'Home trial, warranty & returns',
            'href': '/trial'
        },
        {
            'label': 'Delivery & shipping',
            'href': '/delivery'
        },
        {
            'label': 'Financing with Affirm',
            'href': '/financing'
        }
    ],
    'legalLinks': [
        {
            'label': 'Terms',
            'href': 'https://privacy.saatva.com/privacy-policy#terms-of-use'
        },
        {
            'label': 'Privacy',
            'href': 'https://privacy.saatva.com/privacy-policy'
        },
        {
            'label': 'CA Supply Chains Act',
            'href': 'https://privacy.saatva.com/privacy-policy#california-transparency-in-supply-chains-act-disclosure-statement'
        },
        {
            'label': 'CA Privacy Notice',
            'href': 'https://privacy.saatva.com/privacy-policy#california-privacy-notice'
        },
        {
            'label': 'Accessibility',
            'href': 'https://saatvahelp.zendesk.com/hc/en-us/articles/360050035313-Accessibility'
        },
        {
            'label': 'Do Not Sell My Personal Information',
            'href': 'https://privacy.saatva.com/opt-out'
        }
    ]
}

export const PRODUCT_CODES = {
    // Mattresses
    saatvaClassic: 'saatva-classic',

    // Bases
    foundation: 'foundation',

    // Bedding
    organicCottonSheets:'organic-cotton-sheets',
    organicMattressPad: 'organic-mattress-pad',

    // Bundles
    classicStarterBundle: 'classic-starter-bundle',
    satteenSheetsLatexPillowPad: 'sateen-sheets-latex-pillow-pad',
    sateenSheetsLatexPillow: 'sateen-sheets-latex-pillow',
    sateenSheetsMemoryFoamPillow: 'sateen-sheets-memory-foam-pillow',
    solaire: 'solaire',
}

export const EXCLUDED_SKUS = [EXTEND_SKU]

export  const DISCOUNT_LABELS = {
    bedframeSale: 'Luxury Bed Frame Sale',
    bundle: 'Bundle Discount'
}

export const BUNDLE_CODES = [
    'classic-starter-bundle',
    'sateen-sheets-latex-pillow-pad',
    'sateen-sheets-latex-pillow',
    'sateen-sheets-memory-foam-pillow',
]

export const BUNDLE_PRIMARY_PRODUCTS = {
    [PRODUCT_CODES.saatvaClassic]: ['classic-starter-bundle'],
    [PRODUCT_CODES.organicCottonSheets]: ['sateen-sheets-latex-pillow-pad', 'sateen-sheets-latex-pillow', 'sateen-sheets-memory-foam-pillow'],
}

export const BUNDLE_MODAL_CONFIG = {
    hiddenAttributes: ['quantity', 'mattressHeight', 'comfortLevel'],
    featuresAndBenefitsCopy: {
        foundation: `<b>Mattress Foundation</b> is crafted from North American spruce making it more durable than a traditional box spring`,
        'adjustable-frame': `Comes with a <b>Universal Metal Frame</b> to raise the foundation and mattress off the floor`,
        'organic-mattress-pad': `<b>Mattress Pad</b> with 300 thread count GOTS certified organic cotton protects your mattress from light stains & general wear and tear`
    },
    productNames: {
        foundation: 'Foundation',
        'adjustable-frame': 'Universal Frame',
        'organic-mattress-pad': 'Organic Mattress Pad'
    }
}

export const toppers = {
    subcategory: 'Mattress Toppers',
    mattressRegex: /mattress /i
}

export const CATEGORIES = {
    MATTRESSES: 'mattresses',
    FURNITURE: 'furniture',
    BEDDING: 'bedding',
    BUNDLES: 'bundles',
}

export const FOUNDATION_BUNKIE_BOARD_NAME = 'Foundation & Bunkie Board'

export const pillowBundleSkus = {
    'P27D31CF18-SQ': 'P27D31CF18-2PKQ', // The Saatva Pillow in Queen, 2-Pack Bundle high loft
    'P27D31CF18-K': 'P27D31CF18-2PKK', // The Saatva Pillow in King, 2-Pack Bundle high loft
    'SAOLXPLWLL-Q': 'SAOLXPLL2PK-Q', // The Saatva Pillow in Queen, 2-Pack Bundle standard loft
    'SAOLXPLWLL-K': 'SAOLXPLL2PK-K', // The Saatva Pillow in King, 2-Pack Bundle standard loft
    'SAAGRPHPLW-Q': 'SAAGRPHPLW2PK-Q', // Memory Foam Pillow in Queen, 2-Pack Bundle
    'SAAGRPHPLW-K': 'SAAGRPHPLW2PK-K', // Memory Foam Pillow in King, 2-Pack Bundle
    'SAA5050PLW-Q': 'SAA5050PLW2PK-Q', // Down Alternative Pillow in Queen, 2-Pack Bundle
    'SAA5050PLW-K': 'SAA5050PLW2PK-K', // Down Alternative Pillow in King, 2-Pack Bundle
    'SACLDMFNPLW-Q': 'SACLDMFNP2PK-Q', // Cloud Memory Foam Pillow in Queen, 2-Pack Bundle
    'SACLDMFNPLW-K': 'SACLDMFNP2PK-K', // Cloud Memory Foam Pillow in King, 2-Pack Bundle
    'SAORGQPLW-Q': 'SAORGQPL2PK-Q', // Organic Quilted Pillow in Queen, 2-Pack Bundle
    'SAORGQPLW-K': 'SAORGQPL2PK-K' // Organic Quilted Pillow in King, 2-Pack Bundle
}

export const pillowSizeMap = {
    'Twin': 'Queen',
    'Twin XL': 'Queen',
    'Full': 'Queen',
    'Queen': 'Queen',
    'Upper-Flex Queen': 'Queen',
    'King': 'King',
    'Cal King': 'King',
    'Split King': 'King',
    'Upper-Flex King': 'King'
}

export const DELIVERY_WINDOWS = {
    whiteGloveMattress: {
        start: 7,
        end: 21
    }, 
    whiteGloveFurniture: {
        start: 14,
        end: 28
    },
    whiteGloveSolaire: {
        start: 14,
        end: 28
    },
    fedex: {
        start: 5,
        end: 9
    }
}

export const saatvaContactInfo = {
    email: 'info@saatvamattress.com',
    phone: '1-877-672-2882',
    phoneNumberV0: '1-860-362-2641',
    phoneNumberV1: '1-860-546-3250'
}

export const DELIVERY_SUBTYPES = {
    MATTRESS_AND_FURNITURE: 'mattressAndFurniture',
    MATTRESS_ONLY: 'mattressOnly',
    FURNITURE_ONLY: 'furnitureOnly',
    FEDEX: 'fedex'
}
